import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Spinner from '../Spinner';

/**
 * @callback comparatorCallback
 * @param {any} props
 * @returns {boolean}
 */

/**
 * Composable loader to be used with state props by matching
 * `comparator` predicate as a condition to show the loader
 *
 * @param {comparatorCallback} [comparator]
 * @param {Object} [options]
 */
const withLoader = (comparator = () => {}, options = {}) => (
  (WrappedComponent) => (props) => {
    const Wrapper = (props) => {
      const { isLoading } = props;
      const loading = comparator(props) || isLoading;

      return (
        <Fragment>
          {loading && <Spinner mauto {...options} />}
          {!loading && <WrappedComponent {...props} />}
        </Fragment>
      );
    };

    Wrapper.propTypes = {
      isLoading: PropTypes.bool.isRequired
    };

    return Wrapper(props);
  }
);

withLoader.defaultProps = {
  comparator: null
};

withLoader.propTypes = {
  comparator: PropTypes.func
};

export default withLoader;
